import script from "./LeaderMyCompetenceDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderMyCompetenceDelete.vue?vue&type=script&setup=true&lang=js"

import "./LeaderMyCompetenceDelete.vue?vue&type=style&index=0&id=0ee61084&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee61084"]])

export default __exports__